import axios from "axios";
import moment from "moment";
var CryptoJS = require("crypto-js");

export async function igolfMappingRequest(action, body, user, image) {
  const isPrivate = user ? true : false;
  const ENV = process.env.REACT_APP_ENV;
  
  // DB migration
    // config.host = "https://dev-api.igolf.com";// stage environment for igolf
    // config.apiKey= "sw68shrAhRazPLc";
    // config.secretKey= "DpW-HSZRNAtbWTAUxszqXcHnrN87gF";
// original 
  const config = {
    host: "https://dev-api.igolf.com", // stage environment for igolf
    apiKey: "f0freVAM7LVAfAE",
    secretKey: "k_oZslkAcOqAUXMXgJaQkL82OFb8xk",
  }

  if (ENV === "production") {
    // const config = {
  //   host: "https://igolf-web-services-dev.us-east-1.elasticbeanstalk.com", // live environment for igolf ~ old
  //   apiKey: "b-_8IN1Vpf805Rg",
  //   secretKey: "9GtnxD-bdnXU9j7_pGT0_ZLu3ZJi8x",
  // };
  
    config.host = "https://api-connect3.igolf.com"; // live environment for igolf
    config.apiKey = "WGm7XfXsV78l-Hg";
    config.secretKey = "pWEfron6IMeK8oK7BViAI8f4Dyjqty";
  }
  
  const apiParams = {
    action,
    apiKey: config.apiKey,
    userDetails: user ? user.userName : undefined,
    apiVersion: "1.0",
    signatureVersion: "2.0",
    signatureMethod: "HmacSHA256",
    timestamp: moment().format("YYMMDDHHmmssZZ"),
    responseFormat: "JSON",
  };

  let message2 = Object.keys(apiParams)
    .filter((key) => apiParams[key] !== undefined && apiParams[key].length)
    .map((key) => apiParams[key])
    .join("/");

  const key = config.secretKey + (user && user.secretKey ? user.secretKey : "");
  apiParams.signature = CryptoJS.HmacSHA256(message2, key)
    .toString(CryptoJS.enc.Base64url)
    .replace(/\//g, "_")
    .replace(/\+/g, "-")
    .replace(/=/g, "");
  let url = "";
  if (isPrivate) {
    url = `${apiParams.apiKey}/${apiParams.userDetails}/${apiParams.apiVersion}/${apiParams.signatureVersion}/${apiParams.signatureMethod}/${apiParams.signature}/${apiParams.timestamp}/${apiParams.responseFormat}`;
  } else {
    url = `${apiParams.apiKey}/${apiParams.apiVersion}/${apiParams.signatureVersion}/${apiParams.signatureMethod}/${apiParams.signature}/${apiParams.timestamp}/${apiParams.responseFormat}`;
  }
  try {
   
    let contentType = "application/json"
    if(image === true){
      contentType = "image/json";
    }

    return await axios.post(
      `${config.host}/rest/action/${action}/${url}?UserType=admin`,
      body,
      {
        headers: {
          "Content-Type": contentType,
        },
      }
    );
  } catch (e) {
    console.error("igolfMappingRequest Error:", e);
    return e?.response;
  }
}
